"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var BeardLight_1 = __importDefault(require("./BeardLight"));
var BeardMajestic_1 = __importDefault(require("./BeardMajestic"));
var BeardMedium_1 = __importDefault(require("./BeardMedium"));
var MoustacheFancy_1 = __importDefault(require("./MoustacheFancy"));
var MoustacheMagnum_1 = __importDefault(require("./MoustacheMagnum"));
var react_1 = require("react");
var AvatarContext_1 = __importDefault(require("../../AvatarContext"));
var FacialHairType_1 = __importDefault(require("./FacialHairType"));
function FacialHair() {
    var _a;
    var type = (_a = react_1.useContext(AvatarContext_1.default).facialHairType) !== null && _a !== void 0 ? _a : FacialHairType_1.default.Blank;
    switch (type) {
        case FacialHairType_1.default.Blank:
            return null;
        case FacialHairType_1.default.BeardMedium:
            return jsx_runtime_1.jsx(BeardMedium_1.default, {}, void 0);
        case FacialHairType_1.default.BeardLight:
            return jsx_runtime_1.jsx(BeardLight_1.default, {}, void 0);
        case FacialHairType_1.default.BeardMajestic:
            return jsx_runtime_1.jsx(BeardMajestic_1.default, {}, void 0);
        case FacialHairType_1.default.MoustacheFancy:
            return jsx_runtime_1.jsx(MoustacheFancy_1.default, {}, void 0);
        case FacialHairType_1.default.MoustacheMagnum:
            return jsx_runtime_1.jsx(MoustacheMagnum_1.default, {}, void 0);
    }
}
exports.default = FacialHair;
